var _defs, _path, _rect, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDecoy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    width: "36px",
    height: "40px",
    viewBox: "0.25 0 36 40",
    enableBackground: "new 0.25 0 36 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.704,19.472l1.801,1.009l-0.747,1.275l-1.76-1.01v2.022H6.551v-2.068l-1.847,1.056L4,20.481l1.802-1.009L4,18.417 l0.747-1.274l1.804,1.055v-2.11h1.447v2.066l1.76-1.011l0.703,1.274L8.704,19.472z M11.76,7.964l2.151-1.25l-0.86-1.486L10.979,6.44 V4.016H9.219v2.502l-2.188-1.29L6.172,6.714l2.189,1.25L6.172,9.216l0.859,1.486l2.188-1.251v2.501h1.761V9.528l2.071,1.174 l0.86-1.486L11.76,7.964z M29.534,9.626l1.757-1.055l-0.702-1.274l-1.757,1.011V6.243h-1.451v2.109l-1.802-1.055l-0.748,1.274 l1.76,1.055l-1.76,1.011l0.704,1.274l1.846-1.055v2.065h1.451v-2.021l1.757,1.011l0.748-1.274L29.534,9.626z M16.146,11.645 l-1.323,1.146h-0.618c-0.412,0-0.616,0.207-0.616,0.617v2.822l1.014,0.97v2.073h0.485v2.116h-0.485v2.204h0.485v2.117h-0.485v2.204 h0.485v2.116h-0.485v2.028l-1.014,1.809v1.499c0,0.411,0.204,0.616,0.616,0.616h7.85c0.412,0,0.618-0.205,0.618-0.616v-1.499 l-1.06-1.809v-2.028h-0.441v-2.116h0.441v-2.204h-0.441v-2.117h0.441V21.39h-0.441v-2.116h0.441v-2.073l1.06-0.97v-2.072 l1.763,1.014v12.389l-0.616,0.31c-0.471,0.266-0.824,0.5-1.06,0.707c-0.264,0.234-0.322,0.484-0.175,0.749l0.66,0.133l2.074-1.015 V14.554l-4.102-6.57h-4.851l-0.883,0.134c-0.264,0.116-0.396,0.366-0.396,0.749c0,0.589,0.353,0.927,1.058,1.015V11.645"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "sliceCopy_x5F_9_1_",
    x: 35.337,
    fill: "none",
    width: 20.776,
    height: 40
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "sliceCopy_x5F_8_1_",
    fill: "none",
    width: 35.337,
    height: 40
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDecoy);
export default __webpack_public_path__ + "static/media/decoy.b109fc7a658fcd80793ee7dd0443bcc2.svg";
export { ForwardRef as ReactComponent };